// extracted by mini-css-extract-plugin
export default {"edit_post":"EditPost_edit_post__F4VyW","preview_title":"EditPost_preview_title__k+NVt","title":"EditPost_title__VmPJi"};